import script from "./BonusCampaignRulesRow.vue?vue&type=script&setup=true&lang=js"
export * from "./BonusCampaignRulesRow.vue?vue&type=script&setup=true&lang=js"

import "./BonusCampaignRulesRow.vue?vue&type=style&index=0&id=1278905d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1278905d"]])

export default __exports__